import React, { useState } from "react"
import { LocalizedMatch } from "../../../types/match"
import { TeamBettingStatsWithParameterFlat } from "../../../types/teamBettingStats"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import homeTeamStats from "@assets/images/title-banner/home-team-stats.png"

export const MatchBettingStats = ({
  match,
  awayTeamBettingStats,
  homeTeamBettingStats,
  isH1 = true,
  newTitleBanner = true,
}: {
  match: LocalizedMatch
  homeTeamBettingStats: TeamBettingStatsWithParameterFlat
  awayTeamBettingStats: TeamBettingStatsWithParameterFlat
  isH1?: boolean
  newTitleBanner?: boolean
}) => {
  const [homeStatsType, setHomeStatsType] = useState<keyof TeamBettingStatsWithParameterFlat>("all")
  const [awayStatsType, setAwayStatsType] = useState<keyof TeamBettingStatsWithParameterFlat>("all")

  return (
    <>
      {newTitleBanner && <NewTitleBanner icon={homeTeamStats} title={"Statistiche"} col={{ lg: 12 }} isH1={isH1} />}
      <div
        style={{
          paddingBottom: "0",
          fontSize: "12px",
          lineHeight: 2,
        }}
        className="row marginZero betting-stats-match"
      >
        <div className="row">
          <h3 className="col-6 text-center align-self-center">{match.homeTeam?.name}</h3>
          <h3 className="col-6 text-center align-self-center">{match.awayTeam?.name}</h3>
        </div>
        <div className="row hs-block">
          <div className="col-6 text-center align-self-center team-button-stats">
            <div
              className={
                "single-button-stats" + (homeStatsType.toString() === "home" ? " single-button-stats-active" : "")
              }
              onClick={() => {
                setAwayStatsType("away")
                setHomeStatsType("home")
              }}
            >
              CASA
            </div>
            <div
              className={
                "single-button-stats" + (homeStatsType.toString() === "all" ? " single-button-stats-active" : "")
              }
              onClick={() => {
                setAwayStatsType("all")
                setHomeStatsType("all")
              }}
            >
              COMPLESSIVO
            </div>
          </div>
          <div className="col-6 text-center align-self-center team-button-stats team-button-stats-away">
            <div
              className={
                "single-button-stats" + (awayStatsType.toString() === "all" ? " single-button-stats-active" : "")
              }
              onClick={() => {
                setAwayStatsType("all")
                setHomeStatsType("all")
              }}
            >
              COMPLESSIVO
            </div>
            <div
              className={
                "single-button-stats" + (awayStatsType.toString() === "away" ? " single-button-stats-active" : "")
              }
              onClick={() => {
                setAwayStatsType("away")
                setHomeStatsType("home")
              }}
            >
              FUORI CASA
            </div>
          </div>
        </div>
        <ul className="text-center">
          {homeTeamBettingStats[homeStatsType]?.parameters
            ?.filter((p) => {
              return [
                "CAR",
                "GOL",
                "PG",
                "GOL_AVG",
                "GOLS_AVG",
                "VITX",
                "OVER1T05X",
                "OVER15X",
                "OVER25X",
                "YELCAR",
                "OVER1T15X",
                "BOTHGOLX",
                "CORNER",
                "CORNER_AVG",
                "CSHT",
                "YELCAR_AVG",
                "REDCAR_AVG",
              ].includes(p.code)
            })
            .map((homeTeamBettingStat, index) => {
              const awayTeamBettingStat = awayTeamBettingStats[awayStatsType]?.parameters.find(
                (awayTeamBettingStat) => awayTeamBettingStat.code === homeTeamBettingStat.code,
              )

              const homeValue = homeTeamBettingStat.value
              const awayValue = awayTeamBettingStat?.value

              return (
                <li className="row" key={index}>
                  <div className={"col-4"}>{homeValue + (homeTeamBettingStat.unitMeasurement || "")}</div>
                  <div className="col-4">{homeTeamBettingStat.name}</div>
                  <div className={"col-4"}>{awayValue + (awayTeamBettingStat?.unitMeasurement || "")}</div>
                </li>
              )
            })}
        </ul>
      </div>
    </>
  )
}
